const MAX_ENTRIES = 20;

/**
 * A short, per-device list of keys the player has already been shown something for, kept in
 * localStorage under `storageKey`, newest first and capped at 20. Include the user in the key: a
 * browser can be shared.
 */
export function createSeenList(storageKey: string) {
  const read = (): string[] => {
    try {
      const data = JSON.parse(localStorage.getItem(storageKey) || '[]') as unknown;
      return Array.isArray(data) ? data.filter((value): value is string => typeof value === 'string') : [];
    } catch {
      return [];
    }
  };

  /** Records the key and returns the updated list, newest first. */
  const mark = (key: string): string[] => {
    const seen = read();

    if (seen.includes(key)) {
      return seen;
    }

    const next = [key, ...seen].slice(0, MAX_ENTRIES);

    try {
      localStorage.setItem(storageKey, JSON.stringify(next));
    } catch {
      // Private mode or quota: remembered for this session only.
    }

    return next;
  };

  return { read, mark };
}
